import { createSelector } from 'reselect'
import { urlParams } from './router'

export const initialFormValues = createSelector(urlParams, params => ({
  email: params.email,
}))
